import { get } from 'lodash';

export default {
  validate: (question, visible, answers, payload, config, ln) => {
    const valid = get(answers[question.id], 'part.id') !== undefined
      || get(answers[question.id], 'input') !== undefined;

    return {
      valid,
      messaging: valid ? null : { message: (config.features.pleaseCompleteText[ln] || config.features.pleaseCompleteText['en_US']) + (question.control == 'TextInput' ? (config.features.requiredFieldText[ln] || config.features.requiredFieldText['en_US']) : (config.features.requiredChoiceText[ln] || config.features.requiredChoiceText['en_US'])) }
    }
  }
};



// WEBPACK FOOTER //
// ./src/base/scripts/constraints/RequiredField.js